import React from 'react';
import { Box, Skeleton } from '@mui/material';

const Skeletons = () => (
  <Box display="flex">
    <Box bgcolor="surface.white" mr={3} width={78}>
      <Box alignItems="center" display="flex" height="40px" px={1}>
        <Skeleton variant="text" width="100%" />
      </Box>
    </Box>
    <Box bgcolor="surface.white" width={52}>
      <Box alignItems="center" display="flex" height="40px" px={1}>
        <Skeleton variant="text" width="100%" />
      </Box>
    </Box>
  </Box>
);

export default Skeletons;
